import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../APIRoute";
import { apiCall } from "../../AxiosService";
import { apiResponse } from "../../APIResponse";

export const GetByPrimarykey = createAsyncThunk(
  "GetByPrimarykey",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.PROFILE_DETAIL,
          body: data,
        },
        false
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) { }
  }
);

export const UserProfileUpdate = createAsyncThunk(
  "UserProfileUpdate",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.PROFILE_UPDATE,
          body: data,
        },
        true
      );
      let response = apiResponse(true, resData);

      return response;
    } catch (error) { }
  }
);

export const UpdatePassword = createAsyncThunk(
  "UpdatePassword",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.USER.UPDATE_PASSWORD,
          body: data,
        },
        true
      );
      let response = apiResponse(true, resData);

      return response;
    } catch (error) { }
  }
);
export const GetUserListBySearch = createAsyncThunk(
  "GetUserListBySearch",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.USER.GETUSERLISTBYSEARCH,
          body: data,
        },
        true
      );
      let response = apiResponse(false, resData);

      return response;
    } catch (error) { }
  }
);

const initialState = {
  GetByPrimarykeyData: {
    data: null,
    error: null,
  },
  UserProfileUpdateData: {
    data: null,
    error: null,
  },
  UpdatePasswordData: {
    data: null,
    error: null,
  },
  GetUserListBySearchData: {
    data: null,
    error: null,
  },
};

const UserSlice = createSlice({
  name: "USERSLICE",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetByPrimarykey.fulfilled, (state, action) => {
        state.GetByPrimarykeyData.data = action.payload;
      })
      .addCase(GetByPrimarykey.rejected, (state, action) => {
        state.GetByPrimarykeyData.error = action.error.message;
      })
      .addCase(UserProfileUpdate.fulfilled, (state, action) => {
        state.UserProfileUpdateData.data = action.payload;
      })
      .addCase(UserProfileUpdate.rejected, (state, action) => {
        state.UserProfileUpdateData.error = action.error.message;
      })
      .addCase(UpdatePassword.fulfilled, (state, action) => {
        state.UpdatePasswordData.data = action.payload;
      })
      .addCase(UpdatePassword.rejected, (state, action) => {
        state.UpdatePasswordData.error = action.error.message;
      })
      .addCase(GetUserListBySearch.fulfilled, (state, action) => {
        state.GetUserListBySearchData.data = action.payload;
      })
      .addCase(GetUserListBySearch.rejected, (state, action) => {
        state.GetUserListBySearchData.error = action.error.message;
      });
  },
});

export default UserSlice.reducer;
